import { LISTING_TYPE_URL_SEGMENT_MAP } from 'utils/constants';
import { del, getJson, postJson } from 'utils/http';
import { titleCaseToCamelCase } from 'utils/string';

import { OrgDashboardApiInternship } from './types/OrgDashboardApiInternship';
import { OrgDashboardApiJob } from './types/OrgDashboardApiJob';
import { OrgDashboardApiRepostedListing } from './types/OrgDashboardApiRepostedListing';
import { OrgDashboardApiVolop } from './types/OrgDashboardApiVolop';

type FetchListingDefaultType =
  | OrgDashboardApiJob
  | OrgDashboardApiInternship
  | OrgDashboardApiVolop;

export function fetchListing<T = FetchListingDefaultType>(
  orgId: string,
  listingType: string,
  listingId: string,
): Promise<T> {
  return getJson(
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    `/data/orgdashboard/${orgId}/${LISTING_TYPE_URL_SEGMENT_MAP[listingType]}/${listingId}`,
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  ).then((response) => response[titleCaseToCamelCase(listingType)]);
}

export function hideListing({
  orgId,
  listingId,
  listingType,
}: {
  orgId: string;
  listingId: string;
  listingType: string;
}) {
  return postJson(
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    `/data/orgdashboard/${orgId}/${LISTING_TYPE_URL_SEGMENT_MAP[listingType]}/${listingId}/hide`,
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  ).then((response) => response[titleCaseToCamelCase(listingType)]);
}

export function unhideListing({
  orgId,
  listingId,
  listingType,
}: {
  orgId: string;
  listingId: string;
  listingType: string;
}) {
  return postJson(
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    `/data/orgdashboard/${orgId}/${LISTING_TYPE_URL_SEGMENT_MAP[listingType]}/${listingId}/unhide`,
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  ).then((response) => response[titleCaseToCamelCase(listingType)]);
}

export function deleteListing({
  orgId,
  listingId,
  listingType,
}: {
  orgId: string;
  listingId: string;
  listingType: string;
}) {
  return del(
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    `/data/orgdashboard/${orgId}/${LISTING_TYPE_URL_SEGMENT_MAP[listingType]}/${listingId}`,
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
  ).then((response) => response[titleCaseToCamelCase(listingType)]);
}

export function fetchRepostedListings(
  orgId: string,
): Promise<Array<OrgDashboardApiRepostedListing>> {
  return getJson(`/data/orgdashboard/${orgId}/published-reposts`).then(
    // @ts-expect-error TS(2345): Argument of type '({ listings }: { listings: any; ... Remove this comment to see the full error message
    ({ listings }) => listings,
  );
}
